import React, { lazy, Suspense, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import OrsanLogoLoader from "./OrsanLogoLoader";

// Import pages
import HomePage from "./HomePage";
const ProductPage = lazy(() => import("./ProductPage"));

/** Minimalni čas prikaza – brez motečega utripa pri zelo hitrem nalaganju */
const MIN_LOADER_MS = 450;

const App = () => {
  useEffect(() => {
    const loader = document.getElementById("app-loader");
    if (!loader) return;

    const start = performance.now();
    const remove = () => {
      const elapsed = performance.now() - start;
      const delay = Math.max(0, MIN_LOADER_MS - elapsed);
      loader.style.pointerEvents = "none";
      loader.style.transition = "opacity 0.3s ease-out";
      requestAnimationFrame(() => {
        loader.style.opacity = "0";
      });
      setTimeout(() => loader.remove(), delay + 320);
    };

    const t = setTimeout(remove, MIN_LOADER_MS);
    return () => clearTimeout(t);
  }, []);
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route
        path="/izdelki/:productId"
        element={
          <Suspense fallback={<OrsanLogoLoader fullscreen />}>
            <ProductPage />
          </Suspense>
        }
      />
      <Route
        path="/izdelki/terasne-obloge/:materialId"
        element={
          <Suspense fallback={<OrsanLogoLoader fullscreen />}>
            <ProductPage />
          </Suspense>
        }
      />
      <Route
        path="/izdelki/fasadne-obloge/:materialId"
        element={
          <Suspense fallback={<OrsanLogoLoader fullscreen />}>
            <ProductPage />
          </Suspense>
        }
      />
      <Route
        path="/izdelki/predelne-stene/:materialId"
        element={
          <Suspense fallback={<OrsanLogoLoader fullscreen />}>
            <ProductPage />
          </Suspense>
        }
      />
      <Route
        path="/izdelki/ograje/:materialId"
        element={
          <Suspense fallback={<OrsanLogoLoader fullscreen />}>
            <ProductPage />
          </Suspense>
        }
      />
      <Route
        path="/izdelki/boksi/:materialId"
        element={
          <Suspense fallback={<OrsanLogoLoader fullscreen />}>
            <ProductPage />
          </Suspense>
        }
      />
    </Routes>
  );
};

export default App;
